























































import { Vue, Component } from 'vue-property-decorator';
import ContentLayout from '@components/layouts/Content.vue';
import ListIcon from '@/assets/img/icon-diagnosis.svg';

@Component({
  components: {
    ContentLayout,
  },
})
export default class QuestionTutorial extends Vue {
  iconHeader: any = ListIcon;

  handleBack() {
    this.$router.back();
  }
}
